export default "/images/1da0fa880b574362ee80106ea8a1bff2.avif";